import React, { useEffect } from "react";
import { ModalScreen } from "./modalscreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import PlantillaScreenExtendModal from "./PlantillaScreenExtendModal";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import * as echarts from "echarts";
import request from "../../../../Helpers/API";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../Actions/GetContainer";

export const RazonFinancieraSubItem = ({ titulo, valor, guia, medida, modal, sucursales }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className={getColorClass(valor, guia, medida)}>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto">
            {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>
        </div>
        <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia">
          Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem2 = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className={"dashboard-financiero-razones-financieras-box-container-2 " + getColorClass2(valor, guia, medida)}>
          <div className="dashboard-financiero-razones-financieras-box-d2">
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto2">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia2">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>
        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem2Completo = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className={"dashboard-financiero-razones-financieras-box-container-2-completo " + getColorClass2(valor, guia, medida)}>
          <div className="dashboard-financiero-razones-financieras-box-header-completo">
            {titulo}
          </div>
          <div className="dashboard-financiero-razones-financieras-box-d2">
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto2">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia2">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>
        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem3 = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className="dashboard-financiero-razones-financieras-box-container-3">
          <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div>
          <div className="dashboard-financiero-razones-financieras-box-d3">
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto3">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia3">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>
        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem3Completo = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-container-3-completo">
          <div className="dashboard-financiero-razones-financieras-box-header-completo">
            {titulo}
          </div>
          <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div>
          <div className="dashboard-financiero-razones-financieras-box-d3">
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto3">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia3">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>
        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem4 = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className="dashboard-financiero-razones-financieras-box-container-4">
          {/* <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div> */}
          <div className={"dashboard-financiero-razones-financieras-box-d4 " + getColorClass2(valor, guia, medida)}>
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto4">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-linea-guia4"></div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia4">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>

        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem4_1 = ({ titulo, valor, guia, medida, modal, sucursales, sucursalesSeleccionadas = "", ejercicioSelect = "", periodoSelect = "" }) => {
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory();
  const [currentModal, setCurrentModal] = useState("");
  const [data, setData] = useState({});
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [sucursalesArray, setSucursalesArray] = useState([]);


  useEffect(() => {
    if (!Array.isArray(sucursales)) return;

    const resultado = [
      ...new Set(
        sucursales.flatMap(item => {
          if (typeof item.idsucursal === "string") {
            return item.idsucursal.split(",").map(id => Number(id.trim()));
          }
          return item.idsucursal;
        })
      )
    ];

    setSucursalesArray(resultado);
  }, [sucursales]);

  const onOpenModal = (modal) => {
    setLoader({ ...loader, mostrar: true });
    if (modal === "ProyeccionesScreen") {
      history.push("/Finanzas/ProyeccionesVentas", {
        sucursales
      });
    }
    else if (modal === "ProyeccionesGastosScreen") {
      history.push("/Finanzas/ProyeccionesGastos", {
        sucursales
      });
    }
    else if (modal === "InventarioRotacionMainScreen") {
      history.push("/Finanzas/RotacionInventario");
    }
    else if (modal === "RotacionCXCMainScreen") {
      sessionStorage.removeItem("rotacion_cxc_filtro");
      // if (sucursalesArray.length === 1 || sucursalesSeleccionadas.length === 1) {
      history.push("/Finanzas/RotacionCXC", {
        sucursales,
        sucursalesSeleccionadas: GetKey(sucursalesSeleccionadas, ["idsucursal"]),
        sucursalesSeleccionadasArray: sucursalesSeleccionadas,
        // ejercicioSelect,
        // periodoSelect

      });
      // }
      // else {
      //   history.push("/Finanzas/RotacionCXCSucursal", {
      //     sucursales,
      //     sucursalesSeleccionadas: GetKey(sucursalesSeleccionadas, ["idsucursal"])
      //   });

      // }
    }
    else if (modal === "RotacionCXCOptimaMainScreen") {
      sessionStorage.removeItem("rotacion_cxc_filtro");
      // if (sucursalesArray.length === 1 || sucursalesSeleccionadas.length === 1) {
      history.push("/Finanzas/RotacionCXCOptima", {
        sucursales,
        sucursalesSeleccionadas: GetKey(sucursalesSeleccionadas, ["idsucursal"]),
        sucursalesSeleccionadasArray: sucursalesSeleccionadas,
        optima: true
        // ejercicioSelect,
        // periodoSelect

      });
      // }
      // else {
      //   history.push("/Finanzas/RotacionCXCSucursal", {
      //     sucursales,
      //     sucursalesSeleccionadas: GetKey(sucursalesSeleccionadas, ["idsucursal"])
      //   });

      // }
    }
    else {
      request.get(`InfoModalesDashboardFinanzas/Obtener_FactorAbsorcionModal`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          // console.log(result);
          setCurrentModal(modal);
          setOpenModal(true);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          console.error(error);
        });
    }
  };


  return (
    <>
      <LoaderScreen loader={loader} />
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className="dashboard-financiero-razones-financieras-box-container-4-1">
          {/* <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div> */}
          <div className={getColorClass(valor, guia, medida)}>
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto4">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-linea-guia4"></div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia4">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>

        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} data={data} />}
    </>
  );
};

export const RazonFinancieraSubItem4_2 = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");
  const [data, setData] = useState({});
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const onOpenModal = (modal) => {
    setLoader({ ...loader, mostrar: true });
    request.get(`InfoModalesDashboardFinanzas/Obtener_RotacionActivosModal`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
        console.log(result);
        setCurrentModal(modal);
        setOpenModal(true);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        console.error(error);
      });
  };

  return (
    <>
      <LoaderScreen loader={loader} />
      <div className="dashboard-financiero-razones-financieras-box" onClick={modal ? () => onOpenModal(modal) : undefined}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className="dashboard-financiero-razones-financieras-box-container-4-2">
          {/* <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div> */}
          <div className={getColorClass(valor, guia, medida)}>
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto4">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-linea-guia4"></div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia4">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>

        </div>
      </div>
      {openModal && <CustomModalExtended open={openModal} setOpen={setOpenModal} modalType={currentModal} data={data} />}
    </>
  );
};

export const RazonFinancieraSubItem4_3 = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className="dashboard-financiero-razones-financieras-box-container-4-3">
          {/* <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div> */}
          <div className={getColorClass(valor, guia, medida)}>
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto4">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-linea-guia4"></div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia4">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>

        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};

export const RazonFinancieraSubItem4_4 = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
        <div className="dashboard-financiero-razones-financieras-box-container-4-4">
          {/* <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div> */}
          <div className={"dashboard-financiero-razones-financieras-box-d4 " + getColorClass2(valor, guia, medida)}>
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto4">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-linea-guia4"></div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia4">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>

        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};


export const RazonFinancieraSubItem4Completo = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const onOpenModal = (modal) => {
    setCurrentModal(modal);
    setOpenModal(true);
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={() => onOpenModal(modal)}>
        <div className="dashboard-financiero-razones-financieras-box-container-4-completo">
          <div className="dashboard-financiero-razones-financieras-box-header-completo">
            {titulo}
          </div>
          {/* <div className={"dashboard-financiero-razones-financieras-box-circle " + getColorClassInterior(valor, guia, medida)}></div> */}
          <div className={getColorClass(valor, guia, medida)}>
            <div className="dashboard-financiero-razones-financieras-box-porcentaje-texto4">
              {valor} {`${medida === "porcentaje" ? "%" : "X"}`}
            </div>
          </div>
          <div className="dashboard-linea-guia4"></div>
          <div className="dashboard-financiero-razones-financieras-box-porcentaje-guia4">
            Guía: {guia} {`${medida === "porcentaje" ? "%" : "X"}`}
          </div>

        </div>
      </div>
      {openModal && <CustomModal open={openModal} setOpen={setOpenModal} modalType={currentModal} />}
    </>
  );
};



export const getColorClassInterior = (datoActual, datoObjetivo, medida) => {
  let diferencia;

  if (medida === "porcentaje") {
    diferencia = Math.abs(datoActual - datoObjetivo);
    if (diferencia <= 5) {
      return "circulo-verde-interior";
    } else if (diferencia <= 6) {
      return "circulo-amarillo-interior";
    } else {
      return "circulo-rojo-interior";
    }
  } else if (medida === "numero-vueltas") {
    diferencia = Math.abs(datoActual - datoObjetivo);
    if (diferencia <= 0.5) {
      return "circulo-verde-interior";
    } else if (diferencia <= 1) {
      return "circulo-amarillo-interior";
    } else {
      return "circulo-rojo-interior";
    }
  }

  return "";
};

export const RazonFinancieraSubItem4Blanco = ({ titulo, valor, guia, medida, modal }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState("");
  const [data, setData] = useState({});

  const onOpenModal = (modal) => {
    request.get(`InfoModalesDashboardFinanzas/Obtener_RotacionActivosModal`)
      .then((result) => {
        setData(result);
        console.log(result);
        setCurrentModal(modal);
        setOpenModal(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-box" onClick={modal ? () => onOpenModal(modal) : undefined}>
        <div className="dashboard-financiero-razones-financieras-box-header">
          {titulo}
        </div>
      </div>
      {openModal && <CustomModalExtended open={openModal} setOpen={setOpenModal} modalType={currentModal} data={data} />}
    </>
  );
};

export const getColorClass2 = (datoActual, datoObjetivo, medida) => {
  let diferencia;

  if (medida === "porcentaje") {
    diferencia = Math.abs(datoActual - datoObjetivo);
    if (diferencia <= 5) {
      return "borde-verde";
    } else if (diferencia <= 6) {
      return "borde-amarillo";
    } else {
      return "borde-rojo";
    }
  } else if (medida === "numero-vueltas") {
    diferencia = Math.abs(datoActual - datoObjetivo);
    if (diferencia <= 0.5) {
      return "borde-verde";
    } else if (diferencia <= 1) {
      return "borde-amarillo";
    } else {
      return "borde-rojo";
    }
  }

  return "";
};

export const getColorClass = (datoActual, datoObjetivo, medida) => {
  if (medida === "porcentaje") {
    const porcentaje = (datoActual / datoObjetivo) * 100;
    if (porcentaje <= 60) {
      return "circulo rojo";
    } else if (porcentaje <= 80) {
      return "circulo amarillo";
    } else {
      return "circulo verde";
    }
  } else if (medida === "numero-vueltas") {
    const vueltasPorcentaje = (datoActual / datoObjetivo) * 100;
    if (vueltasPorcentaje <= 60) {
      return "circulo rojo";
    } else if (vueltasPorcentaje <= 80) {
      return "circulo amarillo";
    } else {
      return "circulo verde";
    }
  }
}

const CustomModal = ({ open, setOpen, modalType, data }) => {
  const onClose = () => setOpen(false);
  // if (!data) {
  //   return null; 
  // }
  const refacciones = data?.find(item => item.concepto === 'Factor de Absorción Refacciones')?.valor ?? 0;
  const servicio = data?.find(item => item.concepto === 'Factor de Absorción Servicio')?.valor ?? 0;
  const total = data?.find(item => item.concepto === 'Factor de Absorción')?.valor ?? 0;
  const refaccionesguia = data?.find(item => item.concepto === 'Factor de Absorción Refacciones')?.guia ?? 0;
  const servicioguia = data?.find(item => item.concepto === 'Factor de Absorción Servicio')?.guia ?? 0;
  const totalguia = data?.find(item => item.concepto === 'Factor de Absorción')?.guia ?? 0;
  const refaccionesindicador = data?.find(item => item.concepto === 'Factor de Absorción Refacciones')?.indicador ?? 0;
  const servicioindicador = data?.find(item => item.concepto === 'Factor de Absorción Servicio')?.indicador ?? 0;
  const totalindicador = data?.find(item => item.concepto === 'Factor de Absorción')?.indicador ?? 0;

  const GetIndicador = (datoActual, datoObjetivo, medida) => {
    if (medida === "porcentaje") {
      const porcentaje = (datoActual / datoObjetivo) * 100;
      if (porcentaje <= 60) {
        return "flag-red";
      } else if (porcentaje <= 80) {
        return "flag-yellow";
      } else {
        return "flag-green";
      }
    } else if (medida === "numero-vueltas") {
      const vueltasPorcentaje = (datoActual / datoObjetivo) * 100;
      if (vueltasPorcentaje <= 60) {
        return "flag-red";
      } else if (vueltasPorcentaje <= 80) {
        return "flag-yellow";
      } else {
        return "flag-green";
      }
    }
  }

  const getMedida = (indicador) => {
    if (indicador === "%") return "porcentaje";
    if (indicador === "x") return "numero-vueltas";
  };

  const convertGuiaNumero = (guia) => {
    if (!guia) return 0;
    const value = guia.replace(/[^\d\.x]/g, '');
    if (value.includes('x')) {
      return parseFloat(value.replace('x', ''));
    } else {
      return parseFloat(value);
    }
  };

  const establecerTitulo = (modal) => {
    switch (modal) {
      case 'FactorAbsorcion':
        return 'Factor de Absorción';
      case 'RotacionInventario':
        return 'Rotación de Inventario';
      case 'CapitalActivos':
        return 'Capital a Activos';
      case 'CoberturaIntereses':
        return 'Cobertura de Intereses';
      // case 'GastosFinancieros':
      //   return 'Cobertura de Gastos Financieros';
      default:
        console.log("Desconocido");
    }
  }


  return (
    <ModalScreen close={onClose}>
      <PlantillaScreen titulo={establecerTitulo(modalType)} className={"asc-modal"}>
        <div className="modal-tabla-container">
          <div className="dashboard-financiero-razones-financieras-box-table">
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          refacciones,
                          convertGuiaNumero(refaccionesguia),
                          getMedida(refaccionesindicador)
                        )}`}
                      ></div>
                      <div>Refacciones</div>
                    </div>
                  </td>
                  <td>{refacciones}</td>
                  <td>{refaccionesguia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          servicio,
                          convertGuiaNumero(servicioguia),
                          getMedida(servicioindicador)
                        )}`}
                      ></div>
                      <div>Servicio</div>
                    </div>
                  </td>
                  <td>{servicio}</td>
                  <td>{servicioguia}</td>
                  <td></td>
                </tr>
                <tr className="total">
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          total,
                          convertGuiaNumero(totalguia),
                          getMedida(totalindicador)
                        )}`}
                      ></div>
                      <div>Total</div>
                    </div>
                  </td>
                  <td>{total}</td>
                  <td>{totalguia}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="analisis-as-screen-footer">
          <div className="analisis-as-screen-regresar" onClick={onClose}>
            <ArrowBackIcon />
            Regresar
          </div>
        </div>
      </PlantillaScreen>
    </ModalScreen>
  );
};

const CustomModalExtended = ({ open, setOpen, modalType, data }) => {
  const onClose = () => setOpen(false);
  const getDatos = (concepto) => {
    const item = data.find((item) => item.concepto === concepto);
    return {
      valor: item?.valor ?? 0,
      guia: item?.guia ?? 0,
      indicador: item?.indicador ?? 0,
    };
  };

  const maquinaria = getDatos('Rotación de inventario de Maquinaria');
  const tractores = getDatos('Rotación de inventario de Tractores');
  const implementos = getDatos('Rotación de inventario de Implementos');
  const refacciones = getDatos('Rotación de inventario de Refacciones');
  const productoAliado = getDatos('Rotación de inventario de Producto Aliado');
  const ferreteria = getDatos('Rotación de inventario de Ferretería');
  const sistemasRiego = getDatos('Rotación de inventario de Sistemas de Riego');
  const equipoSatelital = getDatos('Rotación de inventario de Equipo Satelital');
  const maquinariaUsada = getDatos('Rotación de inventario de Maquinaria Usada');
  const total = getDatos('Rotación de Activos');

  const GetIndicador = (datoActual, datoObjetivo, medida) => {
    if (medida === "porcentaje") {
      const porcentaje = (datoActual / datoObjetivo) * 100;
      if (porcentaje <= 60) {
        return "flag-red";
      } else if (porcentaje <= 80) {
        return "flag-yellow";
      } else {
        return "flag-green";
      }
    } else if (medida === "numero-vueltas") {
      const vueltasPorcentaje = (datoActual / datoObjetivo) * 100;
      if (vueltasPorcentaje <= 60) {
        return "flag-red";
      } else if (vueltasPorcentaje <= 80) {
        return "flag-yellow";
      } else {
        return "flag-green";
      }
    }
  }

  const getMedida = (indicador) => {
    if (indicador === "%") return "porcentaje";
    if (indicador === "x") return "numero-vueltas";
  };

  const convertGuiaNumero = (guia) => {
    if (!guia) return 0;
    const value = guia.replace(/[^\d\.x]/g, '');
    if (value.includes('x')) {
      return parseFloat(value.replace('x', ''));
    } else {
      return parseFloat(value);
    }
  };

  const establecerTitulo = (modal) => {
    switch (modal) {
      case 'FactorAbsorcion':
        return 'Factor de Absorción';
      case 'RotacionInventario':
        return 'Rotación de Inventario';
      case 'CapitalActivos':
        return 'Capital a Activos';
      case 'CoberturaIntereses':
        return 'Cobertura de Intereses';
      // case 'GastosFinancieros':
      //   return 'Cobertura de Gastos Financieros';
      default:
        console.log("Desconocido");
    }
  }

  return (
    <ModalScreen close={onClose}>
      <PlantillaScreenExtendModal titulo={establecerTitulo(modalType)} className={"asc-modal-extend"}>
        <div className="modal-tabla-container">
          <div className="dashboard-financiero-razones-financieras-box-table">
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          maquinaria.valor,
                          convertGuiaNumero(maquinaria.guia),
                          getMedida(maquinaria.indicador)
                        )}`}
                      ></div>
                      <div>Maquinaria</div>
                    </div>
                  </td>
                  <td className="celda-valor">{maquinaria.valor}</td>
                  <td>{maquinaria.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          tractores.valor,
                          convertGuiaNumero(tractores.guia),
                          getMedida(tractores.indicador)
                        )}`}
                      ></div>
                      <div>Tractores</div>
                    </div>
                  </td>
                  <td className="celda-valor">{tractores.valor}</td>
                  <td>{tractores.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          implementos.valor,
                          convertGuiaNumero(implementos.guia),
                          getMedida(implementos.indicador)
                        )}`}
                      ></div>
                      <div>Implementos</div>
                    </div>
                  </td>
                  <td className="celda-valor">{implementos.valor}</td>
                  <td>{implementos.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          refacciones.valor,
                          convertGuiaNumero(refacciones.guia),
                          getMedida(refacciones.indicador)
                        )}`}
                      ></div>
                      <div>Refacciones</div>
                    </div>
                  </td>
                  <td className="celda-valor">{refacciones.valor}</td>
                  <td>{refacciones.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          productoAliado.valor,
                          convertGuiaNumero(productoAliado.guia),
                          getMedida(productoAliado.indicador)
                        )}`}
                      ></div>
                      <div>Producto Aliado</div>
                    </div>
                  </td>
                  <td className="celda-valor">{productoAliado.valor}</td>
                  <td>{productoAliado.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          ferreteria.valor,
                          convertGuiaNumero(ferreteria.guia),
                          getMedida(ferreteria.indicador)
                        )}`}
                      ></div>
                      <div>Ferretería</div>
                    </div>
                  </td>
                  <td className="celda-valor">{ferreteria.valor}</td>
                  <td>{ferreteria.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          sistemasRiego.valor,
                          convertGuiaNumero(sistemasRiego.guia),
                          getMedida(sistemasRiego.indicador)
                        )}`}
                      ></div>
                      <div>Sistemas de Riego</div>
                    </div>
                  </td>
                  <td className="celda-valor">{sistemasRiego.valor}</td>
                  <td>{sistemasRiego.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          equipoSatelital.valor,
                          convertGuiaNumero(equipoSatelital.guia),
                          getMedida(equipoSatelital.indicador)
                        )}`}
                      ></div>
                      <div>Equipo Satelital</div>
                    </div>
                  </td>
                  <td className="celda-valor">{equipoSatelital.valor}</td>
                  <td>{equipoSatelital.guia}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          maquinariaUsada.valor,
                          convertGuiaNumero(maquinariaUsada.guia),
                          getMedida(maquinariaUsada.indicador)
                        )}`}
                      ></div>
                      <div>Maquinaria Usada</div>
                    </div>
                  </td>
                  <td className="celda-valor">{maquinariaUsada.valor}</td>
                  <td>{maquinariaUsada.guia}</td>
                  <td></td>
                </tr>
                <tr className="total">
                  <td>
                    <div className="dashboard-financiero-razones-financieras-box-table-indicador">
                      <div
                        className={`dashboard-financiero-razones-financieras-box-table-indicador-flag ${GetIndicador(
                          total.valor,
                          convertGuiaNumero(total.guia),
                          getMedida(total.indicador)
                        )}`}
                      ></div>
                      <div>Total</div>
                    </div>
                  </td>
                  <td className="celda-valor">{total.valor}</td>
                  <td>{total.guia}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="analisis-as-screen-footer">
          <div className="analisis-as-screen-regresar" onClick={onClose}>
            <ArrowBackIcon />
            Regresar
          </div>
        </div>
      </PlantillaScreenExtendModal>
    </ModalScreen>
  );


};
